module.exports = __webpack_public_path__ + "static/media/video-placeholder.b4b5c6e4.png";